import { ReplenishmentTemplateDetailPage } from '@/features/replenishment-template/pages/ReplenishmentTemplateDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateDetailPage,
});
